<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close']);

const accountId = useMapGetter('getCurrentAccountId');

const show = ref(true);
const message = ref('');
const files = ref([]);
const isSending = ref(false);

const onClose = () => emit('close');

const onFileChange = event => {
  files.value = Array.from(event.target.files || []);
};

const submit = async () => {
  if (!message.value.trim() || isSending.value) return;
  isSending.value = true;
  try {
    const form = new FormData();
    form.append('message', message.value);
    files.value.forEach(file => form.append('attachments[]', file));
    await axios.post(`/api/v1/accounts/${accountId.value}/melhorias`, form);
    useAlert('Sugestão enviada! Obrigado pelo feedback.');
    emit('close');
  } catch (error) {
    useAlert('Não foi possível enviar agora. Tente novamente.');
  } finally {
    isSending.value = false;
  }
};
</script>

<template>
  <woot-modal v-model:show="show" :on-close="onClose">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        header-title="Sugerir melhoria"
        header-content="Sua sugestão vai direto para a equipe SiteUp por e-mail."
      />
      <form class="w-full" @submit.prevent="submit">
        <div class="w-full">
          <label>
            Descrição
            <textarea
              v-model="message"
              rows="5"
              placeholder="Descreva sua sugestão ou o problema que encontrou..."
            />
          </label>
          <label class="block mt-2 mb-1">Anexos (opcional — imagem ou PDF)</label>
          <input
            type="file"
            multiple
            accept="image/*,application/pdf"
            class="text-sm"
            @change="onFileChange"
          />
          <ul v-if="files.length" class="mt-2 text-sm list-disc list-inside text-n-slate-11">
            <li v-for="file in files" :key="file.name">{{ file.name }}</li>
          </ul>
          <div class="flex flex-row justify-end w-full gap-2 px-0 py-4">
            <NextButton
              faded
              slate
              type="button"
              label="Cancelar"
              @click="onClose"
            />
            <NextButton
              type="submit"
              label="Enviar"
              :is-loading="isSending"
              :disabled="!message.trim() || isSending"
            />
          </div>
        </div>
      </form>
    </div>
  </woot-modal>
</template>
